import { ReadAllResponse, uuid } from "@/interfaces";
import { Service } from "@/models/services.model";
import type { ServicePriceChange } from "@shyne/shared/api";
import { ServicesRepository } from "@/repositories/services.repository";

export async function fetchServices(): Promise<ReadAllResponse<Service>> {
  return ServicesRepository.getAll();
}

export async function insertService(values: Partial<Service>): Promise<Service> {
  return ServicesRepository.create({ name: values.name ?? "", parent: values.parent, price: values.price, payment: values.payment, priced_per_job: values.priced_per_job });
}

export async function saveServicePrices(changes: readonly ServicePriceChange[]): Promise<Service[]> {
  return ServicesRepository.setPrices(changes);
}

export async function deleteService(id: uuid): Promise<void> {
  return ServicesRepository.delete(id);
}
